import PriceValueCFD from './PriceValueCFD';

export default PriceValueCFD;
